import React, { FC } from "react";
import styled from "styled-components";
import StarIndicator from "../common/StarIndicator";

const CardReviewWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: flex-start;
	align-content: stretch;
	padding: 20px;
	border-bottom: 1px solid #eadced;
	overflow: hidden;
`;

const LabelName = styled.p`
	margin: 0px;
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 165.5%;
	letter-spacing: 0.005em;
	color: #002b49;
`;

const LabelComment = styled.p`
	margin: 0px;
	font-family: Livvic;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 165.5%;
	letter-spacing: 0.005em;
	color: #002b49;
	text-align: left;
	white-space: pre-wrap;
	word-wrap: break-word;
`;

const CommentDate = styled.p`
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 10px;
	line-height: 165.5%;
	letter-spacing: 0.005em;
	color: rgba(0, 43, 73, 0.52);
	margin: 0px;
	text-align: right;
	width: 100%;
`;

interface CardReviewProfessionalProps {
	name: string;
	grade: number;
	comment: string | null;
	date: string;
}

const CardReviewProfessional: FC<CardReviewProfessionalProps> = props => {
	return (
		<CardReviewWrapper>
			<LabelName>{props.name}</LabelName>
			<StarIndicator maxGrade={5} grade={props.grade} />
			<LabelComment>{props.comment}</LabelComment>
			<CommentDate>{props.date}</CommentDate>
		</CardReviewWrapper>
	);
};

export default CardReviewProfessional;
